import React from 'react';
import { Field, Formik } from 'formik';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Toggler } from '@components';
import { RCMVariavelInitialValues, RCMVariavelSchema } from '@schemas';
import { enviaFormRequest } from '@store/user/actions';

export const RCMVariavel = ({ title, reference }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  return (
    <div className="card">
      <div className="card-body">
        <h3 className="fw-bold ts-20 mb-32">{title}</h3>
        <Formik
          validateOnMount
          initialValues={RCMVariavelInitialValues}
          validationSchema={RCMVariavelSchema}
          onSubmit={(values) => {
            dispatch(
              enviaFormRequest({
                campos: values,
                formulario: reference,
                navigate,
              })
            );
          }}
        >
          {({ handleSubmit, isValid }) => (
            <form onSubmit={handleSubmit}>
              <div className="row">
                <Field
                  className="mb-3"
                  name="opcaoRCM"
                  component={Toggler}
                  label="Conforme disposto no Regulamento do Plano Misto de Benefícios Previdenciários da Forluz (Plano B), venho, por meio deste, formalizar minha opção pelo pagamento do benefício da RCM para meus beneficiários na forma de renda financeira, na hipótese de meu falecimento ocorrer enquanto me encontrar na condição de Participante Ativo. Declaro estar ciente que esta opção não é vinculante à opção a ser formalizada quando do requerimento dos benefícios de MAI e MAT."
                />
              </div>

              <hr className="mt-32 mt-xs-0 mb-32" />

              <div className="row">
                <div className="col-12 col-md-6 col-xl-4 ms-0 ms-md-auto">
                  <div className="d-block d-md-flex align-items-center">
                    <Button
                      disabled={!isValid}
                      className="ms-0 ms-md-3"
                      onClick={handleSubmit}
                    >
                      Continuar
                    </Button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  );
};
